export default () => ({
    enabled: false,
    supported: false,
    pending: false,

    init() {
        this.supported = "Notification" in window;

        if (this.supported) {
            this.enabled = Notification.permission === "granted";
        }
    },

    async toggle(enabled) {
        if (!this.supported || this.pending) {
            return;
        }

        this.pending = true;

        try {
            if (enabled) {
                await this.enable();
            } else {
                await this.disable();
            }
        } finally {
            this.enabled = Notification.permission === "granted";
            this.pending = false;
        }
    },

    async enable() {
        if (Notification.permission === "granted") {
            return;
        }

        const permission = await Notification.requestPermission();

        if (permission !== "granted") {
            throw new Error("Notification permission denied");
        }
    },

    async disable() {
        // Notification permissions cannot be revoked programmatically.
        // The user must disable them from their browser/site settings.
    },
});
